import { Component, OnInit, ViewChild,ElementRef, AfterContentInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';
import { JwtHelperService } from "@auth0/angular-jwt";

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit, AfterContentInit {

  routeID = this.route.snapshot.params.id;
  messages:any = [];
  authToken = localStorage.getItem('auth');
  messageList = [];
  users = [];
  allUsers = [];
  isLoading = false;
  currentActiveUser = null;
  currentActiveMessageList = null;
  sideBarUserData;
  openingData;
  employerData;
  unreadMessages = [];
  businessID = this.route.snapshot.params.businessID;
  currentUserId = this.authService.getTokenData().userID;
  @ViewChild("chatMessageContainer", { static: true }) chatMessageContainer: ElementRef;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`}),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.fetchMessageLists();
  }

  ngAfterContentInit() {
    this.route.params.subscribe(params => {
      this.routeID = params['id'];
      //Fetch if 
      this.fetchMessageLists();
    });
  }

  fetchMessageLists(){
      
    this.http.get(environment.MESSAGE_LISTS + '/' + this.routeID, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.employerData = res.message[0]['employer'];

          //Calculate unread messages
          for (let i = 0; i < res.message.length; i++) {
            var msg_list = res.message[i];
            msg_list.unreadMessages = 0;

            for (let j = 0; j < msg_list.messages.length; j++) {
              var msg = msg_list.messages[j];

              if(msg.senderID != this.currentUserId && msg.reciever_has_read == false){
                msg_list.unreadMessages = msg_list.unreadMessages + 1;
              }
              
            }
            
          }
          console.log(res.message)

          this.employerMessageLists();

          this.messageList  = res.message[0];
          this.currentActiveUser = this.messageList['user'];
          this.fetchOpeningData();

          setTimeout(() => {
            this.scrollToBottom();
          },400)




        }
      else {
          
        }
      }, (err: any) => {

        console.log("Error while login :: ", err);
      }
    )
}

fetchUserMessageData(){
  this.http.get(environment.USER_MESSAGE_DATA + '/' + this.currentActiveUser['userID'], this.httpOptions).subscribe(
    (res: any) => {
      if (res.status == 200) {
        this.currentActiveUser = res.message;

      }
     else {
        alert(res.message);
      }
    }
  )
}

fetchOpeningData(){
  var date = new Date();
  var epoch = date.getTime();

  this.http.get(environment.OPENING + '/'+this.messageList['opening']['openingID'], this.httpOptions).subscribe(
    (res: any) => {
      if(res.status == 200 ) {
        this.openingData = res.message;
        console.log(this.openingData)

      }
      else {
        console.log('buu')
        this.openingData;
      }
      
    }, (err: any) => {

    }
  )
}

fetchMessageList(messageListElement){
  this.currentActiveUser = messageListElement.userDetails;
  this.openMessages()


  this.http.get(environment.MESSAGE_LISTS + "/" + messageListElement._id, this.httpOptions).subscribe(
    (res: any) => {
      if (res.status == 200) {

        console.log(res.message[0])
        //Clear unread messages
        this.messageList.forEach(element => {
          if(element._id == messageListElement._id){
            element.unreaded = 0;
          }
        });

        this.currentActiveMessageList = res.message[0];
        setTimeout(() => {
          this.scrollToBottom();

        },100)
      }
     else {
        alert(res.message);
      }
    }
  )
}

autoTextarea(e){
  var textarea = document.getElementById("comment");
  var main = document.getElementById("main");
  var heightLimit = 500; /* Maximum height: 200px */

  textarea.oninput = function() {
    textarea.style.height = ""; /* Reset the height*/
    textarea.style.height = Math.min(textarea.scrollHeight, heightLimit) + "px";
    textarea.setAttribute('style', 'height:' +Math.min(textarea.scrollHeight, heightLimit)+'px!important')

    document.getElementById('main-chat-container').style.marginTop = "0px";
    document.getElementById('main-chat-container').style.marginTop = "-" + (document.getElementById('comment').clientHeight - 40).toString() + "px";
  };
}

OnSendReply(){
  var message = (<HTMLInputElement>document.getElementById("comment")).value;
  var req = {
    message: message,
    messageListID: this.messageList['_id'],
    to: this.currentActiveUser['_id'],
    files: null,
  }

  this.http.post(environment.MESSAGE_LISTS + "/" + this.messageList['_id'] + '/saveMessage', req,this.httpOptions).subscribe(
    (res: any) => {
      if (res.status == 200) {
        this.messageList['messages'].push(res.message);
        (<HTMLInputElement>document.getElementById("comment")).value = "";
        //COMMENT HEIGHT BACK TO NORMAL
        document.getElementById('comment').setAttribute('style', 'height:40px!important')
        document.getElementById('main-chat-container').style.marginTop = "0px";

        setTimeout(() => {
          this.scrollToBottom();

        },100)
      }
     else {
        alert('Viestin tallennuksessa kävi virhe');
      }
    }
  )
}

private scrollToBottom(): void {

  try {
    //smoothscroll.polyfill();
    this.chatMessageContainer.nativeElement.scrollTo({ top: this.chatMessageContainer.nativeElement.scrollHeight, behavior: 'smooth' })
    //this.SmoothVerticalScrolling(this.chatMessageContainer, 300, "bottom")
    // this.myScrollContainer.nativeElement.scroll
    //this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
  } catch (err) { }
}


openMessages(){
document.getElementById('left').classList.add('d-none');
document.getElementById('main-chat-container').classList.remove('d-block');
console.log('open');
}

changeUser(){
document.getElementById('left').classList.remove('d-none');
document.getElementById('main-chat-container').classList.add('d-block');
}

goBack(){
  window.history.back();
}

employerMessageLists() {
  this.http.get(environment.EMPLOYER_MESSAGE_LISTS, this.httpOptions).subscribe(
    (res: any) => {
      if(res.status == 200 ) {
        var messages = res.message;
        var unRead = [];
        var read = [];

        console.log(messages)

        //Calculate unread messages and expiracy

        for (let i = 0; i < messages.length; i++) {
          var msg_list = messages[i];
          msg_list.unreadMessages = 0;
          msg_list.expired = false;

          for (let j = 0; j < msg_list.messages.length; j++) {
            var msg = msg_list.messages[j];

            if(msg.from != this.currentUserId && msg.reciever_has_read == false){
              msg_list.unreadMessages = msg_list.unreadMessages + 1;
              unRead.push(msg_list);
              console.log('huuhuhu')
            }

            if(j+1 == msg_list.messages.length && msg_list.unreadMessages == 0){
              read.push(msg_list);
            }

          }

          //Sort unread by date
          unRead.sort(function(a, b) {
            var dateA = new Date(a.createdDate)
            var dateB = new Date(b.createdDate);
            return dateB.getTime() - dateA.getTime();
          });




          //Merge unread and read
          this.unreadMessages = unRead;
          console.log(this.unreadMessages, 'unread');


        }

      }
      else {
        this.messages = []
      }
      
    }, (err: any) => {

    }
  )
}


}
